Ext.define('SA.view.TableDragCellClone', {
    constructor({el, mouseDownOffset}) {
        this.el = el;
        this.mouseDownOffset = mouseDownOffset;
    },

    destroy() {
        return this.el.remove();
    },

    destroyed() {
        return !this.el.isConnected;
    },

    getRegion() {
        return SA.view.Region.forEl(this.el).growBy(1); 
    },

    syncWithMouseEv(mouseEv) {
        var newClonePosition = SA.view.Position.fromMouseEvent(mouseEv).subtract(this.mouseDownOffset);

        this.el.style.top = `${newClonePosition.getTop()}px`;
        this.el.style.left = `${newClonePosition.getLeft()}px`;
    }
});